import { render, staticRenderFns } from "./ModifyExpirationCustomerOrderModal.vue?vue&type=template&id=00140554&scoped=true&"
import script from "./ModifyExpirationCustomerOrderModal.vue?vue&type=script&lang=ts&"
export * from "./ModifyExpirationCustomerOrderModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00140554",
  null
  
)

export default component.exports